<template>
  <div class="h-100">
    <template v-if="isModule">
      <label :for="`${type}-${item.id}`" class="h-100 w-100 mb-0">
        <b-card :class="['text-center h-100', { active }]">
          <div class="test-logo pt-1 pb-1">
            <img
              v-if="item.image"
              :src="$helper.getImage(item.image.file_name)"
              :alt="item.label"
              class="mb-1 img-fluid"
            >
          </div>
          <div class="title mb-1">
            <strong>{{ item.name }}</strong>
          </div>
          <input
            :id="`${type}-${item.id}`"
            type="radio"
            class="d-none"
            :value="item.id"
            :name="type"
            @click="onCardClick(item.id)"
          >
        </b-card>
      </label>
    </template>
    <template v-else>
      <b-card class="text-center h-100">
        <div class="text-right pt-1 pr-1">
          {{ item.language }}
        </div>
        <div class="test-logo pt-1 pb-1">
          <img
            v-if="item.image"
            :src="$helper.getImage(item.image.file_name)"
            :alt="item.label"
            class="mb-1 img-fluid"
          >
        </div>
        <div class="title mb-1">
          <strong>{{ item.label }}</strong>
        </div>
        <b-btn @click="onSelectTestClick(item.id)">
          {{ $t("actions.do_the_test") }}
        </b-btn>
      </b-card>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'PreparationCardComponent',
    props: {
      type: {
        type: String,
        default: null,
      },
      active: {
        type: Boolean,
        default: false,
      },
      item: {
        type: Object,
        default: null,
      },
      isModule: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        selectedCard: null,
      };
    },
    methods: {
      onCardClick(value) {
        this.selectedCard = !this.selectedCard ? value : null;
        this.$emit('change', this.selectedCard);
      },
      onSelectTestClick(id) {
        this.$emit('select-test', id);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  .card {
    &.active {
      border: 1px solid $primary;
    }

    .test-logo {
      height: 100px;

      img {
        height: 100%;
      }
    }

    .title {
      padding: 0 10px;
    }

    .card-body {
      padding: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
</style>
